/* eslint-disable consistent-return */
import { FormInstance } from 'antd';

/**
 * Unit Conversion Functions
 */

// Mile per hour to Kilometer per hour
export const mphToKmh = (value: number): string => (value * 1.609).toFixed(2);

// Kilometer per hour to Mile per hour
export const kmhToMp = (value: number): string => (value / 1.609).toFixed(2);

// Feet to Meter
export const ftToM = (value: number): string => (value / 3.281).toFixed(2);

// Meter to Feet
export const mToFt = (value: number): string => (value * 3.281).toFixed(2);

// Pounds to Kilogram
export const lbToKg = (value: number): string => (value / 2.205).toFixed(2);

// Pounds to Kilogram
export const kgToLb = (value: number): string => (value * 2.205).toFixed(2);

// Long ton to Tonne
export const ltToT = (value: number): string => (value * 1.016).toFixed(2);

// Tonne  to Long ton
export const tToLt = (value: number): string => (value / 1.016).toFixed(2);

// Square Foot to Square Meter
export const sqFtToSqM = (value: number): string => (value / 10.764).toFixed(2);

// Square Meter to Square Foot
export const sqMToSqFt = (value: number): string => (value * 10.764).toFixed(2);

// Gallon to Liter
export const gallonToLiter = (value: number): string => (value * 3.785).toFixed(2);

// Liter to Gallon
export const literToGallon = (value: number): string => (value / 3.785).toFixed(2);

// Knots to Kilometer per hour
export const knotsToKmh = (value: number): string => (value * 1.852).toFixed(2);

// Kilometer per hour to Knots
export const kmhToKnots = (value: number): string => (value / 1.852).toFixed(2);

/**
 * Switch case function to handle all the types of calculations
 *
 * @param form /form instance where will be saved the returned value
 * @param value /the value to be formated
 * @param unit /the unit case to be calculated meters/kilometers...etc
 * @param name /name of the form field to be updated
 * @param selectedUnit / the selected unit from the user ... imperial | metric
 *
 * @returns the after calculated value from imperial system to metric system
 */

export const unitValueFormat = (
  form: FormInstance,
  value: number,
  unit: string,
  name: string,
  selectedUnit: string,
): string | undefined => {
  if (value === null) {
    return;
  }

  let inputvalue = form.getFieldValue(name);

  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  inputvalue ?? (inputvalue = value);
  let tmp = null;

  if (selectedUnit === 'imperial') {
    switch (unit) {
      case 'kmh':
        tmp = Number(kmhToMp(inputvalue));
        form.setFieldsValue({ [name]: tmp });

        return tmp;
      case 'm':
        tmp = Number(mToFt(inputvalue));
        form.setFieldsValue({ [name]: tmp });

        return tmp;
      case 'kg':
        tmp = Number(kgToLb(inputvalue));
        form.setFieldsValue({ [name]: tmp });

        return tmp;
      case 'lt':
        tmp = Number(tToLt(inputvalue));
        form.setFieldsValue({ [name]: tmp });

        return tmp;
      case 'sqm':
        tmp = Number(sqMToSqFt(inputvalue));
        form.setFieldsValue({ [name]: tmp });

        return tmp;
      case 'gallon':
        tmp = Number(literToGallon(inputvalue));
        form.setFieldsValue({ [name]: tmp });

        return tmp;
      case 'knots':
        tmp = Number(kmhToKnots(inputvalue));
        form.setFieldsValue({ [name]: tmp });

        return tmp;
      default:
        return;
    }
  }

  switch (unit) {
    case 'kmh':
      tmp = Number(mphToKmh(inputvalue));
      form.setFieldsValue({ [name]: tmp });

      return tmp;
    case 'm':
      tmp = Number(ftToM(inputvalue));
      form.setFieldsValue({ [name]: tmp });

      return tmp;
    case 'kg':
      tmp = Number(lbToKg(inputvalue));
      form.setFieldsValue({ [name]: tmp });

      return tmp;
    case 'lt':
      tmp = Number(ltToT(inputvalue));
      form.setFieldsValue({ [name]: tmp });

      return tmp;
    case 'sqm':
      tmp = Number(sqFtToSqM(inputvalue));
      form.setFieldsValue({ [name]: tmp });

      return tmp;
    case 'gallon':
      tmp = Number(gallonToLiter(inputvalue));
      form.setFieldsValue({ [name]: tmp });

      return tmp;
    case 'knots':
      tmp = Number(knotsToKmh(inputvalue));
      form.setFieldsValue({ [name]: tmp });

      return tmp;
    default:
  }
};

export const UnitFormatOnSave = (value: number, unit: string, selectedUnit: string): number => {
  if (value === null) {
    return;
  }

  let inputvalue = null;

  if (selectedUnit === 'metric') {
    switch (unit) {
      case 'kmh':
        inputvalue = Number(kmhToMp(value));

        return inputvalue;
      case 'm':
        inputvalue = Number(mToFt(value));

        return inputvalue;
      case 'kg':
        inputvalue = Number(kgToLb(value));

        return inputvalue;
      case 'lt':
        inputvalue = Number(tToLt(value));

        return inputvalue;
      case 'sqm':
        inputvalue = Number(sqMToSqFt(value));

        return inputvalue;
      case 'gallon':
        inputvalue = Number(literToGallon(value));

        return inputvalue;
      case 'knots':
        inputvalue = Number(kmhToKnots(value));

        return inputvalue;
      default:
    }
  } else {
    return value;
  }
};
